<div class="bg-white custom-hv">
  <div class="container">
    <div class="row justify-content-center mt-4">
      <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
        <img src="assets/images/edu-logo.svg" alt="{{ genericMessage['G0001'] }}" class="img-fluid" />
      </div>
    </div>
    <hr />
    <div class="col-lg-12 col-md-12 col-sm-12 mx-auto pb-5">
      <div class="mt-5">
        <h3 id="registration_heading" tabindex="0">Local Education Agency (LEA) Registration</h3>
      </div>
      <div class="mt-4">
        <form [formGroup]="leaRegistrationForm" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="email">Email</label>
              <input
                type="email"
                id="email"
                placeholder="Enter Email"
                tabindex="0"
                formControlName="email"
                class="Inputs form-control"
                readonly />
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="firstName">First Name<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                placeholder="Enter First Name"
                tabindex="0"
                id="firstName"
                formControlName="firstName"
                class="Inputs form-control text-capitalize"
                maxlength="30"
                minlength="2"
                required
                (input)="onFirstNameInput($event)"
                (blur)="checkForTrailingSpace($event, 'firstName')"
                [ngClass]="{
                  'is-invalid': leaRegistrationForm.get('firstName')?.touched && leaRegistrationForm.get('firstName')?.invalid
                }" />
              <div
                *ngIf="
                  leaRegistrationForm.get('firstName')?.touched && leaRegistrationForm.get('firstName')?.errors as errors
                ">
                <div role="alert" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0001'] }}</div>
                <div role="alert"
                  *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0002'] }}
                </div>
              </div>
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="lastName">Last Name<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                id="lastName"
                placeholder="Enter Last Name"
                tabindex="0"
                formControlName="lastName"
                class="Inputs form-control text-capitalize"
                required
                (input)="onLastNameInput($event)"
                (blur)="checkForTrailingSpace($event, 'lastName')"
                [ngClass]="{
                  'is-invalid': leaRegistrationForm.get('lastName')?.touched && leaRegistrationForm.get('lastName')?.invalid
                }" />
              <div
                *ngIf="leaRegistrationForm.get('lastName')?.touched && leaRegistrationForm.get('lastName')?.errors as errors">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0004'] }}</div>
                <div
                  *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0005'] }}
                </div>
              </div>
            </div>
             <!-- <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="organization">Organization</label>
              <input
                type="text"
                id="organization"
                placeholder="Enter organization"
                tabindex="0"
                formControlName="organization"
                class="Inputs form-control text-capitalize"
                minlength="2"
                maxlength="60"
                required
                readonly
                (input)="onOrganizationInput($event)"
                (blur)="onFieldBlur($event, 'organization')"
                [ngClass]="{
                  'is-invalid': leaRegistrationForm.get('organization')?.touched && leaRegistrationForm.get('organization')?.invalid
                }" />
              <div
                *ngIf="leaRegistrationForm.get('organization')?.touched && leaRegistrationForm.get('organization')?.errors as errors">
                <div role="alert" *ngIf="errors['required']" class="text-danger mt-1 err-font">Please enter an organization.</div>
                <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
                <div role="alert"
                  *ngIf="!errors['required'] && !errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
              </div>
            </div> -->
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="department">Department</label>
              <input
                type="text"
                id="department"
                placeholder="Enter Department"
                tabindex="0"
                formControlName="department"
                class="Inputs form-control text-capitalize"
                minlength="2"
                maxlength="60"
                (input)="ondepartmentInput($event)"
                (blur)="onFieldBlur($event, 'department')"
                [ngClass]="{
                  'is-invalid': leaRegistrationForm.get('department')?.touched && leaRegistrationForm.get('department')?.invalid
                }" />
              <div
                *ngIf="leaRegistrationForm.get('department')?.touched && leaRegistrationForm.get('department')?.errors as errors">
                <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
                <div role="alert"
                  *ngIf="!errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-lg-3">
             <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="title">Title</label>
              <input
                type="text"
                id="title"
                name="title"
                autocomplete="organization-title"
                placeholder="Enter Title"
                tabindex="0"
                formControlName="title"
                class="Inputs form-control text-capitalize"
                minlength="2"
                maxlength="60"
                (input)="onTitleInput($event)"
                (blur)="onFieldBlur($event, 'title')"
               [ngClass]="{
                  'is-invalid': leaRegistrationForm.get('title')?.touched && leaRegistrationForm.get('title')?.invalid
                }" />
              <div
                *ngIf="leaRegistrationForm.get('title')?.touched && leaRegistrationForm.get('title')?.errors as errors">
                <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
                <div
                  *ngIf="!errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
              </div>
            </div>
                <div class="form-group col-lg-3 col-md-6 col-sm-12 position-relative district-multiselect-wrapper">
              <label for="district">District<span class="requiredfield text-danger">*</span></label>
              <p-multiSelect
                id="district"
                [options]="districtList"
                formControlName="district"
                optionLabel="value"
                optionValue="key"
                placeholder="Select District"
                display="chip"
                [showHeader]="true"
                [filter]="true"
                filterPlaceHolder="Search District"
                [style]="{'width':'100%'}"
                styleClass="district-multiselect"
                [ngClass]="{
                  'is-invalid':
                    leaRegistrationForm.get('district')?.touched && leaRegistrationForm.get('district')?.invalid
                }">
                <ng-template pTemplate="selectedItems" let-selectedItems>
                  <ng-container *ngIf="selectedItems?.length > 0; else districtPlaceholder">
                    <div class="district-chip" *ngFor="let item of selectedItems | slice:0:2">
                      {{ getDistrictDisplayName(item) }}
                    </div>
                    <div *ngIf="selectedItems.length > 2" class="district-more-badge"
                         role="button"
                         tabindex="0"
                         [pTooltip]="getRemainingDistrictNames(selectedItems)"
                         tooltipPosition="bottom"
                         tooltipStyleClass="district-tooltip"
                         [escape]="false"
                         [showDelay]="0"
                         [hideDelay]="100"
                         tooltipEvent="hover"
                         (mousedown)="$event.stopPropagation(); $event.preventDefault()"
                         (mouseup)="$event.stopPropagation()"
                         (click)="onDistrictMoreClick($event)"
                         (keydown.enter)="onDistrictMoreClick($event)"
                         (keydown.space)="onDistrictMoreClick($event)"
                         (mouseenter)="$event.stopPropagation()">
                      +{{ selectedItems.length - 2 }} more
                    </div>
                  </ng-container>
                  <ng-template #districtPlaceholder>
                    <span class="district-placeholder-text">Select District</span>
                  </ng-template>
                </ng-template>
              </p-multiSelect>

              <div
                *ngIf="
                  leaRegistrationForm.get('district')?.touched && leaRegistrationForm.get('district')?.errors as errors
                ">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ 'Please select a district.' }}</div>
              </div>
            </div>
           <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="streetAddress">Street Address<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                id="streetAddress"
                placeholder="Enter street Address"
                tabindex="0"
                formControlName="streetAddress"
                class="Inputs form-control text-capitalize"
                minlength="3"
                maxlength="60"
                required
                (input)="onStreetAddressInput($event)"
                (blur)="onFieldBlur($event, 'streetAddress')"
                [ngClass]="{
                  'is-invalid': leaRegistrationForm.get('streetAddress')?.touched && leaRegistrationForm.get('streetAddress')?.invalid
                }" />
              <div
                *ngIf="leaRegistrationForm.get('streetAddress')?.touched && leaRegistrationForm.get('streetAddress')?.errors as errors">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0018'] }} </div>
                <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0052'] }}
                </div>
                <div
                  *ngIf="!errors['required'] && !errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0052'] }}
                </div>
              </div>
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="city">City</label>
              <input
                type="text"
                id="city"
                placeholder="Enter City"
                tabindex="0"
                formControlName="city"
                class="Inputs form-control text-capitalize"
                readonly
                [ngClass]="{
                  'is-invalid': leaRegistrationForm.get('city')?.touched && leaRegistrationForm.get('city')?.invalid
                }" />
            </div>
          </div>
          <div class="row mt-lg-3">
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="state">State</label>
              <input
                type="text"
                id="state"
                placeholder="Enter State"
                tabindex="0"
                formControlName="state"
                class="Inputs form-control text-capitalize"
                readonly
                [ngClass]="{
                  'is-invalid': leaRegistrationForm.get('state')?.touched && leaRegistrationForm.get('state')?.invalid
                }" />
              <div
                *ngIf="leaRegistrationForm.get('state')?.touched && leaRegistrationForm.get('state')?.errors as errors">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">state</div>
                <div
                  *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  state
                </div>
              </div>
            </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="zipCode">ZIP Code<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                id="zipCode"
                placeholder="Enter ZIP Code"
                tabindex="0"
                formControlName="zipCode"
                class="Inputs form-control text-capitalize"
                (blur)="getAddress()"
                (input)="zipCodeFormat($event)"
                 minlength="5"
                maxlength="10"
                required
                [ngClass]="{
                  'is-invalid': leaRegistrationForm.get('zipCode')?.touched && leaRegistrationForm.get('zipCode')?.invalid
                }" />
              <div
                *ngIf="leaRegistrationForm.get('zipCode')?.touched && leaRegistrationForm.get('zipCode')?.errors as errors">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0022'] }}</div>
                <div *ngIf="errors['allZeros']" class="text-danger mt-1 err-font">{{ errorMessage['M0023'] }}</div>
                <div *ngIf="errors['invalidZipLength']" class="text-danger mt-1 err-font">
                </div>
                <div
                  *ngIf="!errors['required'] && !errors['allZeros'] && !errors['invalidZipLength'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0023'] }}
                </div>
              </div>
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="phoneNumber">Phone Number<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                id="phoneNumber"
                formControlName="phoneNumber"
                class="form-control"
                required
                placeholder="Enter Phone Number"
                tabindex="0"
                (input)="formatPhoneNumber($event)"
                numbersOnly
                [ngClass]="{
                  'is-invalid':
                    leaRegistrationForm.get('phoneNumber')?.touched && leaRegistrationForm.get('phoneNumber')?.invalid
                }" />
              <div
                *ngIf="
                  leaRegistrationForm.get('phoneNumber')?.touched && leaRegistrationForm.get('phoneNumber')?.errors as errors
                ">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0016'] }}</div>
                <div *ngIf="!errors['required'] && errors['pattern']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0017'] }}
                </div>
                <!-- <div *ngIf="errors['duplicate']" class="text-danger mt-1 err-font">The phone number entered is already on file.</div> -->
              </div>
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="extension">Extension</label>
              <input
                type="text"
                id="extension"
                placeholder="Enter Extension"
                tabindex="0"
                formControlName="extension"
                class="Inputs form-control text-capitalize"
                minlength="2"
                maxlength="10"
                (input)="onExtensionInput($event)"
               [ngClass]="{
                  'is-invalid': leaRegistrationForm.get('extension')?.touched && leaRegistrationForm.get('extension')?.invalid
                }" />
              <div
                *ngIf="leaRegistrationForm.get('extension')?.touched && leaRegistrationForm.get('extension')?.errors as errors">
                <div
                  *ngIf="(errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
              <div class="form-check mb-0 pb-0">
                <input type="checkbox" id="input_lea_registration_form_terms" formControlName="terms" class="mb-2 mr-3 check-box" required
                  aria-required="true"
                  [attr.aria-describedby]="leaRegistrationForm.get('terms')?.touched && leaRegistrationForm.get('terms')?.invalid ? 'terms-error' : null" />
                <label
                  for="input_lea_registration_form_terms"
                  class="form-check-label mb-0"
                  (click)="$event.preventDefault()"
                  (keypress)="$event.preventDefault()">
                  I have read and agree to the
                  <a href="javascript:void(0)" tabindex="0" class="link-pointer" (click)="openTermsAndConditionsModal($event)"><u>User Agreement.</u></a>
                  <span class="requiredfield text-danger">*</span>
                </label>

              </div>
              <div *ngIf="leaRegistrationForm.get('terms')?.touched && leaRegistrationForm.get('terms')?.errors as errors" class="form-check mt-0">
                  <div id="terms-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0044'] }}</div>
                </div>
              <div class="form-check mt-2 mr-3 mb-0 pb-0">
                <input type="checkbox" id="input_lea_registration_form_consent" formControlName="consent" class="check-box mb-4 mr-3" required
                  aria-required="true"
                  [attr.aria-describedby]="leaRegistrationForm.get('consent')?.touched && leaRegistrationForm.get('consent')?.invalid ? 'consent-error' : null" />
                <label
                  for="input_lea_registration_form_consent"
                  class="form-check-label mb-0"
                  (click)="$event.preventDefault()"
                  (keypress)="$event.preventDefault()">
                  I consent to receive emails and SMS messages from the Nevada Department of Education Online Portal for Application and Licensure for account verification and official communications.
                  <span class="requiredfield text-danger">*</span>
                </label>

              </div>
              <div *ngIf="leaRegistrationForm.get('consent')?.touched && leaRegistrationForm.get('consent')?.errors as errors" class="form-check mt-0">
                <div id="consent-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0044'] }}</div>
              </div>
            </div>
          <hr />
          <div class="row justify-content-end pb-3 mt-2 mr-0 mb-5">
            <div class="d-flex">
              <button type="submit" class="btn btn-primary" [disabled]="leaRegistrationForm.invalid">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <ng-template #content let-modal>
    <div class="modal-content">
      <div class="d-flex text-black modal-header pl-4 pr-4 mt-3">
        <h5 class="font-18">Terms &amp; conditions</h5>
        <button type="button" class="btn p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span class="material-symbols-outlined"> close </span>
        </button>
      </div>

      <div class="modal-body termscondition"></div>
    </div>
  </ng-template>
</div>

<div class="modal-overlay" *ngIf="showModal" (click)="closeModal()" (keydown.escape)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <button class="modal-close" (click)="closeModal()">
      <i class="fas fa-times"></i>
    </button>
    <div class="modal-body">
      <div class="success-icon">
        <img src="../../../assets/images/cardy-ai/tick logo.png" alt="Success" width="60" height="60" />
      </div>
      <p class="modal-subtitle">{{ toastMessage['T0027'] || 'Registration completed. A confirmation email will be sent to you shortly with further instructions.' }}</p>
    </div>
  </div>
</div>
